import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import emailIcon from "../../assets/verified.png";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";
import AuthStatusPage from "./AuthStatusPage";

const ApproveAccountId = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { approvalToken } = useParams();
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("success");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!approvalToken) {
      setStatus("Verification link is missing or invalid.");
      setStatusType("error");
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const verifyApprovalToken = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiUrl}/authverify_account_id?token=${approvalToken}`,
          { method: "POST" },
        );

        if (!isMounted) {
          return;
        }

        if (response.ok) {
          setStatus("Successfully added the user to your account.");
          setStatusType("success");
        } else {
          setStatus("Verification failed. Please try again.");
          setStatusType("error");
        }
      } catch {
        if (!isMounted) {
          return;
        }
        setStatus("An error occurred. Please try again.");
        setStatusType("error");
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    verifyApprovalToken();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, approvalToken]);

  const closePage = () => {
    window.close();
  };

  return (
    isLoading ? (
      <LoadingOverlay />
    ) : (
      <AuthStatusPage
        pageTitle="Account Verification | EMAlpha"
        icon={emailIcon}
        iconAlt="Verification status"
        eyebrow={statusType === "success" ? "Verified" : "Verification issue"}
        title={
          statusType === "success"
            ? "Verification complete"
            : "Verification failed"
        }
        description={status}
        tone={statusType}
        primaryAction={{ label: "Close", onClick: closePage }}
      />
    )
  );
};

export default ApproveAccountId;
